import { render, staticRenderFns } from "./ModalReportDetailRoulette.vue?vue&type=template&id=4446ffc3&"
import script from "./ModalReportDetailRoulette.vue?vue&type=script&lang=js&"
export * from "./ModalReportDetailRoulette.vue?vue&type=script&lang=js&"
import style0 from "./ModalReportDetailRoulette.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports